<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="47.906"
        height="44.523"
        viewBox="0 0 47.906 44.523">
        <path
            id="Caminho_1154"
            data-name="Caminho 1154"
            fill="currentColor"
            d="M27.28,54.886V46.892a1.963,1.963,0,0,1,1.963-1.963c3.868,0,5.972-3.967,6.264-11.8H29.243a1.964,1.964,0,0,1-1.963-1.963V14.291a1.963,1.963,0,0,1,1.963-1.963h16.7a1.964,1.964,0,0,1,1.963,1.963V31.17a43.357,43.357,0,0,1-1.123,10.239,24.631,24.631,0,0,1-3.486,8.1,17.013,17.013,0,0,1-5.922,5.412,16.862,16.862,0,0,1-8.134,1.925A1.965,1.965,0,0,1,27.28,54.886ZM1.963,44.929A1.963,1.963,0,0,0,0,46.891v7.995a1.963,1.963,0,0,0,1.963,1.962,16.857,16.857,0,0,0,8.132-1.925,16.986,16.986,0,0,0,5.923-5.412A24.608,24.608,0,0,0,19.5,41.406a43.334,43.334,0,0,0,1.122-10.238V14.29a1.963,1.963,0,0,0-1.963-1.963H1.963A1.963,1.963,0,0,0,0,14.29V31.168a1.963,1.963,0,0,0,1.963,1.963H8.138C7.85,40.962,5.776,44.929,1.963,44.929Z"
            transform="translate(0 -12.327)" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
